"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var format = exports.format = function format(phone) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  // get number only, remove +1
  var phoneNumber = phone.replace(/\D/g, "").slice(-10);
  var numberLength = phoneNumber.length;

  if (numberLength === 10) {
    var output = sep ? ["$1", "$2", "$3"].join(sep) : "($1) $2-$3";
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, output);
  } else if (numberLength === 7) {
    return phoneNumber.replace(/(\d{3})(\d{4})/, "$1-$2");
  }

  return phone;
};

var PhoneLink = function PhoneLink(props) {
  var children = props.children,
      className = props.className,
      icon = props.icon,
      iconClassName = props.iconClassName,
      noIcon = props.noIcon,
      separator = props.separator,
      title = props.title,
      restProps = _objectWithoutProperties(props, ["children", "className", "icon", "iconClassName", "noIcon", "separator", "title"]);

  return _react2.default.createElement(
    "a",
    _extends({
      className: (0, _classnames2.default)("erg-components-PhoneLink", "erg-link", className),
      href: "tel:+1-" + format(children, "-"),
      title: title
    }, restProps),
    !noIcon && _react2.default.createElement(_Icon2.default, { className: iconClassName, icon: icon }),
    format(children, separator)
  );
};

PhoneLink.defaultProps = {
  icon: "phone",
  noIcon: false
};

PhoneLink.displayName = "PhoneLink";

PhoneLink.propTypes = {
  children: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  noIcon: _propTypes2.default.bool,
  separator: _propTypes2.default.string,
  title: _propTypes2.default.string
};

exports.default = PhoneLink;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/PhoneLink.js
 ** module id = 788
 ** module chunks = 0
 **/